import React from 'react';
import View from './view.js';
import { formatDate, monthDayYear } from 'utils/dateHelpers';

let TodaysDateLogic = () => (
  <View value={formatDate(new Date(), 'date', monthDayYear)} />
);

export default TodaysDateLogic;
